<template>
  <div class="row">
    <div class="col-12 row p-3" v-for="userCourse in courses" :key="userCourse.id">
      <div class="col-4 col-lg-3 pl-3">
        <circle-progress :progress-number="userCourse.sectionsPassedPct || 0"></circle-progress>
      </div>
      <div class="col-8 col-lg-8 offset-lg-1 text-center text-md-left mt-3 mt-md-0 pt-3">
        <router-link :to="'/training_plan/' + userCourse.course_id" v-if="userCourse.is_enabled">
          <h3 class="text-blue d-sm-down-none">{{ userCourse.name ? userCourse.name : userCourse.course.name }}</h3>
          <h6 class="text-blue d-block d-md-none">{{ userCourse.name ? userCourse.name : userCourse.course.name }}</h6>
        </router-link>
        <template v-else>
          <h3 class="text-blue d-sm-down-none">{{ userCourse.name ? userCourse.name : userCourse.course.name }}</h3>
          <h6 class="text-blue d-block d-md-none">{{ userCourse.name ? userCourse.name : userCourse.course.name }}</h6>
        </template>
        <p class="font120">{{ userCourse.modulesPassed }} out of {{ userCourse.modulesTotal }} modules complete</p>
        <div class="row p-0 m-0">
          <div class="col-12 col-lg-4 text-left" v-for="userModule in userCourse.user_modules" :key="userModule.id">
            <font-awesome-icon icon="check-circle" class="text-lime" v-if="userModule.is_complete || userCourse.is_completed"></font-awesome-icon>
            <font-awesome-icon icon="arrow-circle-right" class="text-orange" v-if="!userModule.is_complete && !userCourse.is_completed && userModule.start_date"></font-awesome-icon>
            <font-awesome-icon icon="arrow-circle-right" class="text-grey" v-if="!userModule.is_complete && !userCourse.is_completed && !userModule.start_date"></font-awesome-icon>
            {{ userModule.module.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleProgress from './CircleProgress';

export default {
  name: 'ProgressionCharts',
  components: {CircleProgress},
  props: ['courses']
};
</script>

<style scoped>

</style>